import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../../index";
import { api } from "@/lib";
import { GetImportHeaderResponse } from "@/models/api/dataInterchange/importHeader";
import { GetImportOrdersResponse } from "@/models/api/dataInterchange/importOrder";


@Module({ name: "interchange", dynamic: true, store: Store, namespaced: true })
export default class DataInterchangeModule extends VuexModule {
    @Action
    async getImportHeader(importHeaderId) : Promise<GetImportHeaderResponse> {
        const url = `/interchange/ImportHeader?ImportHeaderId=${importHeaderId}`;
        const response = await api.getAsync(url);
        return response.data;
    }

    @Action
    async getImportOrders(importHeaderId) : Promise<GetImportOrdersResponse> {
        const url = `/interchange/ImportOrders?ImportHeaderId=${importHeaderId}`;
        const response = await api.getAsync(url);
        return response.data;
    }
}